module.exports = __webpack_public_path__ + "static/media/eminence-asakusa-2.4d61955d.jpg";